import { render, staticRenderFns } from "./InvoiceSelect.vue?vue&type=template&id=12710d9c&scoped=true"
import script from "./InvoiceSelect.vue?vue&type=script&lang=js"
export * from "./InvoiceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12710d9c",
  null
  
)

export default component.exports